var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:[
    'header',
    { 'header--small': _vm.small },
    { 'header--no-shadow': _vm.noShadow }
  ]},[(!_vm.$slots['default'])?_c('div',{staticClass:"header__items"},[(_vm.$slots['header-left'])?_c('section',{staticClass:"header__left"},[_vm._t("header-left")],2):_vm._e(),(_vm.$slots['header-center'])?_c('section',[_vm._t("header-center")],2):_c('h4',[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.$slots['header-right'])?_c('section',{staticClass:"header__right"},[_vm._t("header-right")],2):_vm._e()]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }